import { Card } from "@/components/ui/card";

export default function ProfileCard() {
  return <Card className="aspect-[3/4] overflow-hidden" />;
}
